import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  List,
  Grid2x2X,
  Grid2X2,
  Grid2x2,
  ListTodo,
  ChevronLeft,
  ChevronDown} from 'lucide-react';

const DropDownButtonUIClient =({dashboardCard1Object,activeCard,icon,title ,onClickSendObject,hasDropDown,dropDownObject})=>{

    const [hasDropDownI ,setHasDropDownI] =useState(hasDropDown)
 const [dropDownObjectI ,setDropDownObjectI] =useState(dropDownObject)

 const Icon=   icon===0?<BookDown size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />:icon===1?<NotepadText size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} 
        />:icon===2?<BookA size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color}  
        />:icon===3?<GalleryHorizontal size={23}   color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color}  
        />:icon===4?<MonitorPlay size={23} color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} 
        />:icon===5?
       <Aperture size={23}   color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />
       :icon===6?<Blocks size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />:icon===7?<CalendarCog size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />
       :icon===8?<X size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />:icon===9?<Plus size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />
:icon===10?<Grid2X2 size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />:icon===11?<ListTodo size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />
:icon===12?<ChevronLeft size={23}  color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />:"";
     
 const iconWhite=   icon===0?<BookDown size={23}  color="#fff" />:icon===1?<NotepadText size={23}  color="#fff" 
 />:icon===2?<BookA size={23}  color="#fff"  
 />:icon===3?<GalleryHorizontal size={23}   color="#fff"  
 />:icon===4?<MonitorPlay size={23} color="#fff" 
 />:icon===5?
<Aperture size={23}   color="#fff" />
:icon===6?<Blocks size={23}  color="#fff" />:icon===7?<CalendarCog size={23}  color="#fff" />
:icon===8?<X size={23}  color="#fff" />:icon===9?<Plus size={23}  color="#fff" />
:icon===10?<Grid2X2 size={23}  color="#fff" />:icon===11?<ListTodo size={23}  color="#fff" />
:icon===12?<ChevronLeft size={23}  color="#fff" />:"";

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const cardBg =activeCard?"rgba(255,114,94,0.1)":" #fff";
      const styleCard={marginBottom:"0px",marginBottom:"0px",height:"30px",width:"160px",cursor:"pointer",background:cardBg,padding:"5px",border:`3px solid ${dashboardCard1Object?.filterDropdownTab?.bgColor?.color}`,}
      const cardBgIcon =activeCard?"rgba(255,114,94,0.7)":" #f9f9f9";
      const styleCardIconIcon={background:cardBgIcon,width:"30px",height:"20px",borderRadius:"15%",
        alignContent:"center",textAlign:"center",padding:"5px",}
        function getBorderTitle(value) {
  const found = dropDownObjectI?.find(item => item?.value === value);
  return found ? found?.title : "Unknown";
}
      return (<>
        <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickSendObject()} align="left" className="itemPageDropDounMenu"
 style={styleCard} > 
<div style={styleCardIconIcon}>{activeCard?iconWhite:Icon}</div>
 <div className=" TitleWithEllipsis" style={{fontSize:"14px",padding:"7px 5px",textAlign:"center",fontWeight:"bold"}}>{getBorderTitle(title)}</div>
{hasDropDownI?<div style={{position:"absolute",right:"5px",top:"0px",padding:"6px",width:"24px",height:"24px",borderRadius:"50%",background:"#ffff"}}>{<ChevronDown size={25}   color={dashboardCard1Object?.filterDropdownTab?.bgColor?.color} />}</div>:""}
 {hasDropDownI?<div className="itemPageDropDounMenuInn" style={{maxHeight:"150px",width:"166px",top:"40px",left:"-2.5px",border:`3px solid ${dashboardCard1Object?.filterDropdownTab?.bgColor?.color}`,borderBottomLeftRadius:"15px",borderBottomRightRadius:"15px",padding:"2px"}}>
     
     {dropDownObjectI?.map((item ,index)=>(<div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickSendObject(item?.value)} align="left" className="itemPageDropDounMenuTitle"
    style={{background:title==item?.value?dashboardCard1Object?.filterDropdownTab?.bgColor?.color:"#fff"}}>
    <div className=" TitleWithEllipsis" style={{fontSize:"15px",padding:"7px 10px",textAlign:"center",fontWeight:"bold"}}>{item?.title}</div> </div>))}
 </div>:<></>}
   </div></>)
}
export default DropDownButtonUIClient;

